<template>
  <div class="sidebar-container" v-if="links.length > 0">
    <div class="sidebar__user-info">
      <div class="user-info__headpic">
        <img :src="avatar" alt />
      </div>
      <div class="user-info__nickname">{{ nickname }}</div>
      <div class="user-info__role">
        <i v-if="userInfo.isMerchant && userInfo.isAuthMerchant" class="item__icon icon icon-vips"></i>
        {{ identityName }}
      </div>
      <div class="user-deadline" v-if="userInfo.isMerchant && userInfo.isAuthMerchant">
        <p :class="{
          'is-delay': userInfo.isDated,
        }">
          到期时间：
          <strong>{{ userInfo.end_time | parseTime }}</strong>
          <br />到期剩余时间：
          <strong>{{ userInfo.end_time | parseTimeDay }}天</strong>
          <br />
          <span v-if="userInfo.type != 4">
            当前剩余积分：
            <strong>{{ integral }}</strong>
          </span>
        </p>
        <p class="hint is-delay" v-if="userInfo.isMerchant && userInfo.isAuthMerchant && userInfo.isDated">
          *请在小程序端进行续费</p>
      </div>
    </div>
    <div class="sidebar__links">
      <div class="links__item" v-for="(link, index) in links" :key="index" :class="[
        link.disable || (userInfo.identity == 4 && link.url == '/my/collects') ? 'disable' : '',
      ]" @click="
  (link.disable || (userInfo.identity == 4 && link.url == '/my/collects')) && gojump(link)
">
        <div v-if="link.name == '我的商城'">
          <!-- <a :href="'https://store.clzx.net/index.php?ctl=Join&met=jump&typ=e&token=xy&user_id='+userInfo.id" target="_blank" class="item__link router-link-exact-active" > -->
          <a :href="
            'https://store.clzx.net/index.php?ctl=Join&met=cf_jump&type_id=2&user_id=' +
            userInfo.id +
            '&store_id=' +
            userInfo.store_id
          " target="_blank" class="item__link router-link-exact-active">
            <i class="item__icon icon" :class="[link.icon]"></i>
            <p class="item__text">{{ link.name }}</p>
          </a>
        </div>
        <div v-else-if="link.name == '商城管理后台'">
          <a :href="
            'https://store.clzx.net/index.php?ctl=Join&met=jump&typ=e&token=xyadmin&user_id=' +
            userInfo.id
          " target="_blank" class="item__link router-link-exact-active">
            <i class="item__icon icon" :class="[link.icon]"></i>
            <p class="item__text">{{ link.name }}</p>
          </a>
        </div>
        <div v-else-if="link.name == '我的订单'">
          <a :href="
            'https://store.clzx.net/index.php?ctl=Join&met=cf_jump&type_id=1&user_id=' +
            userInfo.id
          " target="_blank" class="item__link router-link-exact-active">
            <i class="item__icon icon" :class="[link.icon]"></i>
            <p class="item__text">{{ link.name }}</p>
          </a>
        </div>
        <!-- <div v-else-if="link.name == '认领项目'">
          <a target="_blank" class="item__link router-link-exact-active">
            <i class="item__icon icon" :class="[link.icon]"></i>
            <p class="item__text" @click="goLqClaim" style="cursor: pointer">{{ link.name }}</p>
          </a>
        </div> -->
        <div v-else-if="link.name == '零泉搜索'">
          <a target="_blank" class="item__link router-link-exact-active">
            <i class="item__icon icon" :class="[link.icon]"></i>
            <p class="item__text" @click="goLqClaim">{{ link.name }}</p>
          </a>
        </div>
        <div v-else @click="onClick(link)">
          <router-link class="item__link" tag="a" :to="link.url">
            <i class="item__icon icon" :class="[link.disabledIcon]"
              v-if="userInfo.identity == 4 && link.url == '/my/collects'"></i>
            <i class="item__icon icon" :class="[link.icon]" v-else></i>
            <p class="item__text" :class="{ 'red-important1': userInfo.type == 4 && link.url == '/my/requirements' }">
              {{ link.name }}
              <span class="red-important" v-if="userInfo.type == 4 && link.url == '/my/requirements'">(平台优先解决)</span>
              <span v-if="link.unread && link.unread > 0" class="red-c"></span>
            </p>
            <p v-if="link.name == '项目信息'">
              <span v-if="hasProjectNews" class="red-c"></span>
            </p>
            <p v-if="link.name == '浏览记录'">
              <span v-if="hasLookStoreNews" class="red-c"></span>
            </p>
          </router-link>
        </div>
      </div>
    </div>
    <div class="search-btn" v-if="userInfo.type == 4">
      <p>
        <span class="search-btn-link">按图搜索</span>
      </p>
      <el-upload ref="uploadBD" class="baiduSearch-uploader" action="#" :data="uploadData" :show-file-list="false"
        :before-upload="beforeAvatarUpload">
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <p class="text-p">按图片搜索</p>
    </div>
    <div class="search-btn sc-c" v-if="userInfo.identity != 1" @click="scVisible = true">
      石材专搜
    </div>
    <div class="search-btn" v-if="userInfo.type == 4">
      <p>
        <el-link class="search-btn-link" :underline="false" href="http://reserve.material-online.cn" target="_blank">
          预约宣讲</el-link>
      </p>
    </div>
    <el-dialog custom-class="sc-s-dialog" title="石材专搜" :visible.sync="scVisible" width="30%">
      <span>关键字：</span>
      <el-input placeholder="请输入关键字" v-model="searchVal" style="width: 80%">
        <template slot="append">
          <!-- <a
            :href="`https://www.stone365.com/trade/supplylist.html?keyword=${searchVal}`"
            target="_blank"
          >
          </a> -->
          <el-button type="primary" @click="onSearch">搜索</el-button>
        </template>
      </el-input>
    </el-dialog>

    <template>
      <div>
        <el-dialog title="用户授权协议" :visible.sync="dialogVisible" width="50%">
          <el-form :model="authMobileFormModel" ref="formRef" label-width="50%" size="small"
            class="designer-add-info-c clearfix">
            <div class="lsm-container" style="height: 300px">
              <el-scrollbar class="scrollbar-wrapper" style="height: 100%; line-height: 22px">
                本《信息授权协议》（以下简称“本协议”）由上海材赋信息科技有限公司，即材料在线平台（以下简称“材料在线”）与用户（以下简称“您”）进行缔结，对双方具有同等法律效力。<br />
                <br />
                在您使用“灵感板块功能”相关服务（以下简称“本服务”）之前，请您务必审慎阅读、充分理解本协议各条款内容。如果您不同意本协议的任一或全部条款内容，请不要以确认形式进行下一步操作（包括但不限于勾选/点击同意、填写/提交个人信息等）或使用本服务。一旦您以确认形式进行下一步操作或使用本服务的，即表示您与材料在线已达成协议关系，您自愿接受本协议并遵守本协议项下的全部约定。<br />

                1.在您点击确定/授权后，当您使用灵感板块服务时，我们会将您的账户、手机号码及相关信息共享给材料在线委托的技术服务代理商苏州零泉科技有限公司。前述第三方将使用您的前述信息用于第三方为您提供服务。页面提示上可能会展示具体授权对象、授权字段名称、范围等，授权字段通过加密通道传递给第三方。<br />
                2.
                您理解，材料在线是中立平台的提供者，第三方服务由该第三方独立运营并独立承担全部责任。<br />
                3.
                材料在线在遵守“合法正当、最小必要、目的明确”原则的前提下共享您的个人信息。我们将对个人信息的共享活动事先进行个人信息保护影响评估，对输出形式、流转、使用等采取有效的技术保护措施。在合作协议层面，严格要求合作伙伴的信息保护义务与责任，与业务合作伙伴在合作前签署关于数据安全的保护协议。<br />
                4.
                材料在线深知个人信息对您的重要性，因此材料在线非常重视保护您的个人信息，亦将您的个人信息以高度审慎的义务对待和处理。<br />
                5.
                本协议的解释及争议解决均应适用中华人民共和国大陆地区法律。如就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向被告住所地人民法院提起诉讼。<br />
                6.
                如您在阅读本协议过程中有任何疑惑或其他相关事宜的，您可通过材料在线客服渠道联系材料在线；同时，您也可以发邮件至cailiaozaixian@163.com。材料在线会尽快为您作出解答。<br />
              </el-scrollbar>
            </div>
            <br />
            <p style="text-align: center">下滑滚动查看协议内容</p>

            <br />
            <el-radio v-model="radio" label="1" color="#fabe00"><label>授权账号信息及手机号，以便使用该功能</label>
            </el-radio>
            <el-form-item>
              <el-button type="primary" @click="toCreateAuth">确 定</el-button>
              <el-button @click="cancelCreateAuth" class="el-button-cancel">取 消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </template>
  </div>
</template>

<script>
import { upload } from "@/api/common";
import { getLqRedirectUrl } from "@/api/lq";
import {
  addSearchJumpLog,
  createAuth,
  getLookStoreNewFlag,
  getProjectInfoNewFlag,
  getRealTimeUserInfo,
  isAuth,
} from "@/api/user";
import localstorage from "@/assets/utils/localstorage";
import Bus from "@/components/Bus.vue";
import { Message } from "element-ui";
import { mapState } from "vuex";

export default {
  props: {
    links: {
      type: Array,
      default: () => [],
    },
    avatar: {
      type: String,
      default: null,
    },
    nickname: {
      type: String,
      default: null,
    },
    identityName: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      radio: "1",
      currItemObj: {
        pageType: 3,
      },
      authMobileFormModel: {
        authMobile: false,
      },
      isAuthEd: false,
      dialogVisible: false,

      uploadData: {
        access_token: "",
      },
      scVisible: false,
      hasLookStoreNews: false,
      hasProjectNews: false,
      searchVal: "",
      searchFile: "",
      integral: 0,
    };
  },
  mounted: function () {
    console.log("mounted");
    this.flushRealTimeUserInfo();
  },
  computed: {
    ...mapState({
      userInfo: ({ user: { info } }) => info,
    }),
  },
  watch: {
    scVisible(v) {
      if (!v) {
        this.$set(this, "searchVal", "");
      }
    },
  },
  created() {
    this.init();
    this.checkisAuthEd();
    Bus.$on("setLookedStoreNewFlag", (data) => {
      this.init();
    });
  },
  methods: {
    flushRealTimeUserInfo() {
      getRealTimeUserInfo().then((res) => {
        this.integral = res.data.integral;
      });
    },
    async checkisAuthEd() {
      if (this.isAuthEd == true) {
        return;
      }
      const res = await isAuth();
      this.isAuthEd = res.data;
    },

    cancelCreateAuth() {
      this.dialogVisible = false;
    },
    async toCreateAuth() {
      this.dialogVisible = false;
      await createAuth({
        mobile: this.authMobileFormModel.authMobile == true ? 1 : 0,
      });

      const res = await getLqRedirectUrl(this.currItemObj);
      window.open(res.data);
    },
    async checkisAuthEd() {
      if (this.isAuthEd == true) {
        return;
      }
      const res = await isAuth();
      this.isAuthEd = res.data;
    },

    async goLqClaim() {
      if (this.isAuthEd != true) {
        this.dialogVisible = true;
      } else {
        const res = await getLqRedirectUrl(this.currItemObj);
        window.open(res.data);
      }
    },
    gojump(link) {
      let msg = this.userInfo.isDated ? "您的账号已到期，请续费" : "升级厂家店，解锁更多功能";
      let isSjs = false;
      if (this.userInfo.identity == 4 && link.url == "/my/collects") {
        isSjs = true;
        msg = "材料清单功能仅对设计企业账号开放使用";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: isSjs ? "注册设计企业" : "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (isSjs) {
            this.$router.push({
              path: "/my/authDisign",
            });
          } else {
            this.$router.push({
              path: "/my/auth",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    gosearch(val) {
      this.$router.push({
        path: `/whole/search/case/${val}`,
      });
    },

    beforeAvatarUpload(file) {
      //image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/bmp
      // console.log(file, 'file')
      const isJPEG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isJPG = file.type === "image/jpg";
      const isLt5M = file.size / 1024 / 1024 < 8;
      if (!isJPG && !isPNG && !isJPEG) {
        this.$message.error("上传图片只能是 JPG, jpeg, png  格式!");
        return false;
      }
      if (!isLt5M) {
        Message({
          type: "warning",
          message: `上传图片大小不能超过 8MB!`,
        });
        return false;
      }
      this.uploadData.access_token = localstorage.get("TOKEN");
      this.preLoad = [];
      this.preLoad.push(file);
      upload(this.preLoad).then((res) => {
        // baiduSearch(res[0].data.id).then(resS => {
        //   this.gosearch(resS.data.name);
        // });
        this.searchFile = res[0].data.url;
        this.$router.push({
          path: `/whole/search/case/`,
          query: {
            file: res[0].data.url,
          },
        });
      });
      return true;
    },
    onSearch() {
      if (!this.searchVal && !this.searchFile) {
        this.$message.error("请输入关键字或选择图片");
        return;
      }
      addSearchJumpLog({ title: this.searchVal }).then((res) => {
        window.open(`https://www.stone365.com/trade/supplylist.html?keyword=${this.searchVal}`);
      });
    },
    onClick(link) {
      if (link.name == "浏览记录") {
        console.log(link.name, 666);
      } else if (link.name == "项目信息") {
        console.log(link.name, 666);
      }
    },
    async init() {
      let res1 = await getLookStoreNewFlag();
      let res2 = await getProjectInfoNewFlag();
      // console.log(res1, res2, 678)
      this.hasLookStoreNews = res1.data.flag;
      this.hasProjectNews = res2.data.flag;
      // that.$store.commit('user/SET_INFO', userInfo);
    },
  },
};
</script>

<style lang="scss">
.red-important {
  color: red;
}

.search-btn {
  background: #fabe00;
  color: #fff;
  text-align: center;
  line-height: 40px;
  font-size: 15px;
  cursor: pointer;
  position: relative;

  .text-p {
    position: absolute;
    top: 42px;
    left: 44px;
    border-radius: 8px;
    // padding: 10px;
    background: #fff;
    width: 100px;
    text-align: center;
    font-size: 14px;
    color: #333;
    display: none;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
    z-index: 9;
  }

  &:hover {
    .text-p {
      display: block;
    }
  }

  .search-btn-link {
    color: #333;
    font-size: 15px;
    letter-spacing: 4px;
    font-weight: 600;
    // &:hover {
    //   color: #706d4a;
    // }
  }
}

.sc-c {
  background: #ddd;
  font-weight: 600;
  color: #333;
  letter-spacing: 4px;
}

.baiduSearch-uploader {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;

  .el-icon-plus,
  .el-upload {
    width: 100%;
    line-height: 40px;
  }
}

.sc-s-dialog {
  margin-top: 30vh !important;

  .el-dialog__body {
    padding-top: 20px;
  }
}

.red-c {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: red;
  display: inline-block;
  margin-left: 6px;
}

.el-radio__label {
  margin-right: 10px;
  color: #000 !important;
  font-weight: 200;
}

.el-radio__input.is-checked {
  color: #fabe00 !important;
}

.el-radio__input.is-checked .el-radio__inner {
  background: #fabe00 !important;
  border-color: #fabe00 !important;
}
</style>
